/** Shared copy for React recovery UI and the non-React panic/chunk shells. */

export const RECOVERY_TITLE = "We spilled the Coffee....";

export const RECOVERY_BODY_PRIMARY =
  "Our kitchen is tidying things up right now. Your order and account are safe.";

export const RECOVERY_BODY_SECONDARY = "Please try again in a moment.";

export const RECOVERY_PRIMARY_LABEL = "Try again";

export const RECOVERY_SECONDARY_LABEL = "Back to home";
